export const iconFontAwesomeTravelHotelSailboat = (
	<i className="fa-solid fa-sailboat"></i>
);
